import { create } from "zustand";

type TimelineState = {
  now: number;
  _timeoutId: ReturnType<typeof setTimeout> | null;
  _intervalId: ReturnType<typeof setInterval> | null;
};

type TimerActions = {
  start: () => void;
  stop: () => void;
};

type TimerState = TimelineState & TimerActions;

const SECOND_IN_MS = 60_000;

export const useTimerStore = create<TimerState>((set, get) => ({
  now: Date.now(),
  _timeoutId: null,
  _intervalId: null,

  start: () => {
    const state = get();
    if (state._intervalId || state._timeoutId) return; // вже запущено

    const now = Date.now();
    const msUntilNextMinute = SECOND_IN_MS - (now % SECOND_IN_MS);

    set({ now });

    const timeoutId = setTimeout(() => {
      set({ now: Date.now(), _timeoutId: null });

      const intervalId = setInterval(() => {
        set({ now: Date.now() });
      }, SECOND_IN_MS);

      set({ _intervalId: intervalId });
    }, msUntilNextMinute);

    set({ _timeoutId: timeoutId });
  },

  stop: () => {
    const { _timeoutId, _intervalId } = get();
    if (_timeoutId) clearTimeout(_timeoutId);
    if (_intervalId) clearInterval(_intervalId);
    set({ _timeoutId: null, _intervalId: null });
  },
}));
